import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import { toast } from "vue-sonner";

import { useGlobalLoading } from "@/composable/useGlobalLoading";
import axios from "axios";
import type {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import * as _ from "lodash";
import { isNotBlank } from "~/composable/util";

const apiCount = ref(0);

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();
  const route = useRoute();
  const config = useRuntimeConfig();
  const { showLoading, hideLoading } = useGlobalLoading();

  // loading overlay 제외 Url 목록
  const excludeLoadingOverlayUrlList = ["/api/base/authorization", "/api/base/code-map"];

  axios.defaults.withCredentials = true;

  const showGlobalLoading = () => {
    showLoading();
  };

  const hideGlobalLoadingIfDone = () => {
    if (apiCount.value <= 0) {
      apiCount.value = 0;
      hideLoading();
    }
  };

  const axiosInstance = axios.create({
    timeout: 5000,
    headers: {
      "Content-Type": "application/json",
    },
    baseURL: config.public.apiBase,
  });

  // const glob = import.meta.glob("~/assets/images/*", {
  //   eager: true,
  // });

  // const loadingImageUrl = () => {
  //   return glob[`/assets/images/loading.gif`]['default'];
  // };

  axiosInstance.interceptors.request.use(
    async (config) => {
      if (config.data instanceof FormData) {
        config.headers["Content-Type"] = "multipart/form-data";
      }

      // config의 요청url 획득
      const requestUrl = config.url || "";

      // excludeLoadingOverlayUrlList 배열에 url이 하나라도 포함되어 있으면 loading 처리 제외
      const isExclude = excludeLoadingOverlayUrlList.some((url) => requestUrl.includes(url));

      // 이 요청이 로딩에 포함되는지 표시!
      config._showLoading = !isExclude;

      if (!isExclude) {
        //  -----시작
        if (config._showLoading) {
          apiCount.value += 1;
          if (apiCount.value === 1) {
            showGlobalLoading();
          }
        }
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  axiosInstance.interceptors.response.use(
    (response) => {
      // TODO: 로딩 이미지 종료 임시처리
      // 이 응답이 로딩 대상이면 차감!
      if (response.config?._showLoading) {
        apiCount.value -= 1;
        hideGlobalLoadingIfDone();
      }
      return response.data.body;
    },
    async (error) => {
      // 실패해도 로딩 대상이면 차감!
      const cfg = error?.config as InternalAxiosRequestConfig | undefined;
      if (cfg?._showLoading) {
        apiCount.value -= 1;
        hideGlobalLoadingIfDone();
      }
      const status = _.get(error, "response.status", 999);
      const showAlert = _.get(error, "response.data.showAlert", false);
      const message = _.get(error, "response.data.message", false);
      const redirectUrl = _.get(error, "response.data.redirectUrl", false);

      if (showAlert) {
        toast.warning(message);

        // Swal.fire({
        //   html: message,
        //   icon: "error",
        //   confirmButtonColor: "#AC030A",
        //   confirmButtonText: "확인",
        // }).then(() => {
        //   if (isNotBlank(redirectUrl)) {
        //     router.push({ path: redirectUrl });
        //     return;
        //   }
        // });
      }

      if (status === 999) {
        toast.error('알 수 없는 오류가 발생하였습니다 관리자에게 문의해주세요');
      } else if (status === 401) {
        if(window.location.pathname === '/login') {
          return Promise.reject(error.response.data);
        } else {
          alert('현재 로그인이 되어있지 않습니다\n로그인 페이지로 이동합니다')
          window.location.href = '/login';
        }
      } else if (status === 403) {
        // alert('권한 부족')
        // 권한 부족
      } else {
        // alert('그 외 오류')
        // 그 외에 알고 있는 오류들들
      }

      // else if (status !== 403) {
      //   if(error.response.data['showAlert']) {
      //     Swal.fire({
      //       html: error.response.data.errorMsg || '알 수 없는 오류가 발생하였습니다 관리자에게 문의해주세요',
      //       icon: 'error',
      //       confirmButtonColor: '#AC030A',
      //       confirmButtonText: '확인'
      //     })
      //   }
      //   if (error.response.data['redirectUrl']) {
      //     router.push({path: error.response.data['redirectUrl']});
      //     return error;
      //   }

      //   // if (error.response.data['retry']) {
      //   //   if(retryCount.value == 0) {
      //   //     retryCount.value++;
      //   //     return axiosInstance(error.config);
      //   //   }
      //   // }
      //   // if(!error.response.data['skipAlert']) {
      //   //   Swal.fire({
      //   //     html: error.response.data.errorMsg || '알 수 없는 오류가 발생하였습니다 관리자에게 문의해주세요',
      //   //     icon: 'error',
      //   //     confirmButtonColor: '#AC030A',
      //   //     confirmButtonText: '확인'
      //   //   })
      //   // }
      // } else {
      //   // needLogin();
      // }
      return Promise.reject(error.response.data);
    }
  );
  return {
    provide: { axios: axiosInstance },
  };
});
